document.addEventListener("DOMContentLoaded", function () {

  function filterVariantImages() {

    let checkedVariant = document.querySelector('input[type="radio"]:checked');

    if (!checkedVariant) return;

    let variantName = checkedVariant.value.trim().toLowerCase();

    console.log("Selected Variant:", variantName);

    const thumbs = document.querySelectorAll(".thumbnail-list__item");
    let firstVisibleThumb = null;

    thumbs.forEach(function (thumb) {

      const img = thumb.querySelector("img");

      if (!img) return;

      const alt = (img.alt || "").trim().toLowerCase();

      if (alt === variantName) {
        thumb.style.display = "";
        if (!firstVisibleThumb) {
          firstVisibleThumb = thumb;
        }
      } else {
        thumb.style.display = "none";
      }

    });

    // First visible thumbnail active karo
    if (firstVisibleThumb) {
      const btn = firstVisibleThumb.querySelector("button");
      if (btn) btn.click();
    }

  }

  document.addEventListener("change", function (e) {

    if (e.target.matches('input[type="radio"]')) {
      setTimeout(filterVariantImages, 100);
    }

  });

  setTimeout(filterVariantImages, 100);

});